import { COOKIE_CONSENTS } from '@/stores/AppStore'

class BrowserService {
  getMobileOS() {
    const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;

    // Check for iOS
    if (/iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream) {
      return 'iOS';
    }

    // Check for Android
    if (/android/i.test(userAgent)) {
      return 'Android';
    }

    // Fallback if neither
    return 'unknown';
  }
  isMobile = () => /android|blackberry|iemobile|ipad|iphone|ipod|opera mini|webos/i.test(navigator.userAgent)

  isTablet = () => window.innerWidth < 992

  isWideScreen = () => window.innerWidth > 1200

  sessionId = () => (window as any).sessionId

  appInstanceId = () => (window as any).appInstanceId

  isMobileWebview = (platform?: string) => {
    const userAgent = window.navigator.userAgent.toLowerCase()
    if (userAgent.includes('WebViewMobileApp'.toLowerCase())) {
      if (platform) {
        const lowerCasePlatform = platform.toLowerCase()
        switch (lowerCasePlatform) {
          case 'ios': {
            return userAgent.includes(lowerCasePlatform)
          }
          case 'android': {
            return userAgent.includes(lowerCasePlatform)
          }
          default: {
            return false
          }
        }
      }
      return true
    }

    return false
  }

  isDesktop = () => {
    return !this.isMobileWebview()
  }

  supportApplePay = () => {
    return (window as any).ApplePaySession || this.isMobileWebview('ios')
  }

  platform = () => {
    return this.isMobileWebview() ? 'application' : 'web'
  }

  loadCookiesConsentFromStorage() {
    try {
      const cookieConsents = localStorage.getItem(COOKIE_CONSENTS)
      if (cookieConsents) {
        return JSON.parse(cookieConsents)
      }
      return []
    } catch {
      return []
    }
  }
}

export default new BrowserService()
